import React from 'react';

import {
  JuridictionAdminResponseDto,
  JuridictionViolationDtoFormFieldEnum,
} from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { useRefJuridiction } from 'hooks/referentiels/useRefJuridiction';
import { useSubmitReferentielForm } from 'hooks/referentiels/useSubmitReferentielForm';
import { useValidateReferentielForm } from 'hooks/referentiels/useValidateReferentielForm';

import { JuridictionFormValue } from '../types';
import { buildDefaultUpdateFormValues, buildDto } from '../utils/utils';

import ModalEdition from './ModalEdition';

interface ModalUpdateProps {
  juridiction: JuridictionAdminResponseDto;
  close: () => void;
  visible: boolean;
  refreshDashboard: () => void;
}

export default function ModalUpdate({
  juridiction,
  close,
  visible,
  refreshDashboard,
}: ModalUpdateProps): React.ReactElement {
  const { data: juridictionParente } = useRefJuridiction(
    juridiction.idCorrelationJuridictionParent,
    'modalUpdateJuridictionParente',
  );
  const initials = buildDefaultUpdateFormValues(
    juridiction,
    juridictionParente,
  );
  const { AdminFonctionnelControllerApi } = useApi();
  const { submit, inProgress } = useSubmitReferentielForm(
    refreshDashboard,
    close,
    (values: JuridictionFormValue) =>
      AdminFonctionnelControllerApi.updateJuridictionUsingPUT(
        juridiction.idCorrelation,
        buildDto(values),
      ),
  );
  const { validate } = useValidateReferentielForm(
    (
      field: JuridictionViolationDtoFormFieldEnum,
      values: JuridictionFormValue,
    ) =>
      AdminFonctionnelControllerApi.validateUpdateJuridictionFieldUsingPOST(
        field,
        juridiction.idCorrelation,
        buildDto(values),
      ),
    response => response.juridictionViolationsDto ?? [],
  );

  return (
    <ModalEdition
      close={close}
      visible={visible}
      title="Mise à jour de la Juridiction"
      initials={initials}
      isSubmitting={inProgress}
      submit={submit}
      validate={validate}
    />
  );
}
